import { ElMessage } from 'element-plus'
import axios from 'axios'
import router from '@/router'

// 默认配置
const service = axios.create({
  // baseURL: process.env.VUE_APP_URL_BASE,
  baseURL: '/api/',
  timeout: 30000,
})

// 请求数据
service.interceptors.request.use(
  config => {
    if (config.url.indexOf('http') == -1) {
      if (config.baseURL && config.module) {
        config.baseURL += config.module
      }
    }
    if (config.method === 'post') {
      config.headers['Content-Type'] = 'multipart/form-data'
    } else {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
    config.headers['token'] = localStorage.getItem('token')
    config.headers['platform'] = process.env.VUE_APP_PLATFORM
    return config
  },
  error => {
    if (error.message == 'interrupt') {
      console.log('已中断请求')
      return
    } else {
      return Promise.reject(error)
    }
  }
)

// 返回数据
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 900) {
      // 登录超时
      router.push('/login')
    } else {
      return res
    }
  },
  error => {
    const status = error.response?.status
    const url = `${error.config?.baseURL || ''}${error.config?.url || ''}`
    ElMessage.error(status ? `${status}: ${url}` : error.message)
    return Promise.reject(error)
  }
)

export default service
